export default function PortfolioPreview() {
  const portfolioItems = [
    {
      image: 'https://public.readdy.ai/ai/img_res/7aed562b7f4321eba6787c4169b49e31.jpg',
      category: '목형 제작',
      title: '산업용 주조 목형'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=laser%20cut%20wooden%20wedding%20invitation%20card%20intricate%20floral%20pattern%20elegant%20design%20professional%20photography%20white%20background%20detailed%20laser%20cutting%20craftsmanship%20beautiful%20ornate%20details%20warm%20tones&width=600&height=400&seq=portfolio-2&orientation=landscape',
      category: '레이저 커팅',
      title: '청첩장 레이저 커팅'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=laser%20engraved%20wooden%20photo%20portrait%20detailed%20wood%20burning%20art%20professional%20photography%20clean%20background%20personalized%20gift%20custom%20engraving%20high%20quality%20craftsmanship%20warm%20wood%20tones&width=600&height=400&seq=portfolio-3&orientation=landscape',
      category: '레이저 마킹',
      title: '우드포토 각인'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=custom%20wooden%20packaging%20mold%20pattern%20industrial%20design%20professional%20product%20photography%20clean%20background%20precision%20manufacturing%20detailed%20wooden%20form%20packaging%20industry%20warm%20tones&width=600&height=400&seq=portfolio-4&orientation=landscape',
      category: '목형 제작',
      title: '포장재 목형'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=laser%20cut%20acrylic%20LED%20mood%20lamp%20modern%20design%20glowing%20light%20professional%20photography%20dark%20background%20intricate%20pattern%20decorative%20lighting%20contemporary%20style&width=600&height=400&seq=portfolio-5&orientation=landscape',
      category: '레이저 커팅',
      title: 'LED 무드등'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=laser%20engraved%20metal%20nameplate%20professional%20signage%20clean%20design%20industrial%20marking%20stainless%20steel%20plate%20custom%20engraving%20high%20quality%20finish%20modern%20style&width=600&height=400&seq=portfolio-6&orientation=landscape',
      category: '레이저 마킹',
      title: '금속 명패 각인'
    }
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">대표 작업물</h2>
          <p className="text-lg text-slate-600">재기목형의 정밀한 기술력을 확인하세요</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {portfolioItems.map((item, index) => (
            <div
              key={index}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-xl bg-slate-100 aspect-[3/2] mb-4 shadow-md hover:shadow-xl transition-all duration-300">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <div className="text-sm font-semibold text-amber-400 mb-1">{item.category}</div>
                  <h3 className="text-xl font-bold">{item.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/portfolio"
            className="inline-flex items-center gap-2 bg-slate-800 hover:bg-slate-900 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <span>전체 포트폴리오 보기</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
